<template>
  <div>
    <unlimited-list :fetch-page="getCoupons" ref="unlimitedListRef">
      <template v-slot:default="props">
        <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
          <coupon-item :item="props.item" @couponDeleted="couponDeleted" />
        </vs-col>
      </template>
    </unlimited-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";
import CouponItem from "./CouponItem.vue";

export default {
  name: "CouponsList.vue",
  components: {
    CouponItem,
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    getCoupons(page) {
      return providerApiService.getProviderCoupons(
        this.currentProvider.id,
        page
      );
    },
    couponDeleted(coupon) {
      this.$refs.unlimitedListRef.deleteItem(coupon);
    },
    createCoupon(coupon) {
      this.$refs.unlimitedListRef.createItem(coupon);
    },
  },
};
</script>
